import React from "react";

const BuddiesFilled = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
        <g fill="none" fillRule="evenodd">
            <path
                d="M11.161 25.71c1.357 0 4.522-1.798 4.522-4.494 1.356 0 1.356-2.696 0-2.696l-.453-2.246c-3.617 0-3.617-1.348-4.069-1.798-.452.45-.452 1.798-4.069 1.798L6.64 18.52c-1.356 0-1.356 2.696 0 2.696 0 2.696 3.165 4.493 4.521 4.493z"
                stroke={color}
                strokeWidth=".9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.161 11.33c6.33 0 5.878 4.494 5.878 4.494l-.462 3.371-.04-.093c-.163-.34-.448-.582-.854-.582l-.453-2.246c-3.617 0-3.617-1.348-4.069-1.798-.452.45-.452 1.798-4.069 1.798L6.64 18.52c-.442 0-.74.287-.894.673l-.462-3.369s-.452-4.493 5.877-4.493z"
                fill={color}
            />
            <path
                d="M8.862 24.823L3.11 26.388a3.594 3.594 0 00-2.348 3.365V32H21.7v-2.247c0-1.602-.915-2.573-1.829-2.97-.61-.263-2.438-.917-5.486-1.96l-2.714 3.447"
                stroke={color}
                strokeWidth=".9"
                fill={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.449 19.42c0-.496.404-.449.904-.449s.904-.047.904.45M12.066 19.42c0-.496.404-.449.904-.449s.904-.047.904.45"
                stroke={color}
                strokeWidth=".9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.558.727h-9.143a3.657 3.657 0 00-3.657 3.657V8.04a3.657 3.657 0 003.657 3.657h.914v3.657l4.115-3.657h4.114a3.657 3.657 0 003.657-3.657V4.384A3.657 3.657 0 0028.558.727z"
                stroke={color}
                strokeWidth=".9"
                fill={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default BuddiesFilled;
